import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker';
import logout from './../../Global/logout';

export default async function GetUsersList(
    clientUuid
) {

    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }
    return await resolve(
        axios( 'provider/client/users?clientUuid=' + clientUuid, {
            method: 'get',
            headers: { 'Authorization' : unHashedJwt.data}           
        }).then(res => res)
        .catch(error => error.response.data),
        "Admin"
        );
}